<template>
  <div
    class="original-article"
    :style="{'z-index':showPreview?10:2}"
  >
    <div
      v-if="isShowPage"
      ref="content"
      class="content"
    >
      <div ref="contentC">
        <div
          v-if="false"
          class="form-title"
        >
          <span></span>
          案例内容
        </div>
        <neditor
          :key="dialogData.key"
          v-model="dialogData.context"
          :father-type="'case'"
          :scroll-dom="scrollDom"
        />

        <wang-editor
          v-if="false"
          :key="dialogData.key"
          v-model="dialogData.context"
          class="editor"
          height="400px"
          placeholder="请输入内容"
        />

        <div class="form-title">
          <span></span>
          案例设置
        </div>
        <mk-form
          ref="articleForm"
          class="form"
          :rules="rules"
          :model="dialogData"
        >
          <mk-form-item
            label="案例标题："
            prop="title"
            label-width="100px"
          >
            <mk-input
              v-model="dialogData.title"
              width="320"
              placeholder="输入案例标题"
              maxlength="30"
              class="title-input"
            >
              <div slot="suffix">
                <span>{{ dialogData.title.length }}</span>
                <span>/30</span>
              </div>
            </mk-input>
          </mk-form-item>
          <mk-form-item
            ref="cover"
            label="封面图片："
            prop="cover"
            label-width="100px"
            class="mk-form-item-cover"
          >
            <mk-upload-oss-biz
              :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
              :limit-size="2"
              accept=".jpg,.png"
              @on-upload="onImageUpload"
            >
              <div
                v-loading="imagesLoading"
                class="upload-cover"
              >
                <div
                  v-if="dialogData.cover"
                  class="cover-div"
                >
                  <mk-image
                    :src="dialogData.cover"
                    fit="cover"
                    class="cover-img"
                    alt="cover"
                  />
                  <mk-iconfont
                    icon-class="guanbihuojingshihuocuowu"
                    class="icon"
                    @click.native.stop="dialogData.cover=''"
                  />
                </div>

                <mk-iconfont
                  v-else
                  icon-class="xinzeng"
                  class="plus-icon"
                />
              </div>
            </mk-upload-oss-biz>
            <div class="tips">
              只能上传jpg/png文件，不超过2M
            </div>
          </mk-form-item>
          <!-- <mk-form-item
            label="案例摘要："
            label-width="100px"
            prop="summary"
            class="mk-form-item-summary"
          >
            <mk-input
              v-model="dialogData.summary"
              type="textarea"
              placeholder="可简要介绍案例内容"
              maxlength="50"
              width="370"
              height="120"
              show-word-limit
            />
          </mk-form-item> -->
          <mk-form-item
            label="打标签规则："
            label-width="100px"
            class="mk-form-item-tag-rules"
          >
            <!-- <span class="tips-rules">微信用户访问页面时，当满足符合的条件，会给他打上所设置的行为标签；多个规则同时存在时，标签会进行累加</span> -->
            <tag-rules
              ref="tagRules"
              :key="dialogData.key"
              v-model="dialogData.rules"
              :rules-data="dialogData"
              type="case"
            />
          </mk-form-item>
          <!-- 2020-09-24  hzq 新增的【联系员工】逻辑-->
          <activity-code-switch-biz
            :material-data="dialogData"
          />
          <!-- 活码开关 -->
          <!-- <mk-form-item
            label-width="100px"
            class="mk-form-item-live-code"
          >
            <span
              slot="label"
            >
              <mk-popover
                v-if="qrCodeWarningStatus"
                placement="bottom-start"
                trigger="hover"
                content="该活码已停用"
              >
                <mk-iconfont
                  slot="reference"
                  icon-class="jingshi"
                  class="qrcode-tips"
                />
              </mk-popover>
              活码：
            </span>
            <activity-code-switch
              :dialog-data="dialogData"
              @activity-code="getActivityCode"
              @is-enable-code="getEnableCodeStatus"
            />
          </mk-form-item> -->
        </mk-form>
      </div>
    </div>

    <div
      v-if="isShowPage"
      class="handle"
    >
      <mk-button-biz
        width="64px"
        height="32px"
        @click="goBack"
      >
        返回
      </mk-button-biz>
      <mk-button-biz
        width="64px"
        height="32px"
        @click="preview"
      >
        预览
      </mk-button-biz>
      <mk-button-biz
        width="64px"
        height="32px"
        type="primary"
        @click="checkFormData"
      >
        提交
      </mk-button-biz>
    </div>
    <div
      class="handle-btn-bottom"
      @click="gotoBottom"
    >
      <mk-iconfont
        class="icon"
        icon-class="huidaodibu"
      ></mk-iconfont>
      案例设置
    </div>
    <div
      class="handle-btn-top"
      @click="gotoTop"
    >
      <mk-iconfont
        class="icon"
        icon-class="huidaodingbu"
      ></mk-iconfont>
      回到顶部
    </div>
    <preview
      v-if="showPreview"
      :show="showPreview"
      :dialog-data="dialogData"
      @cancel="cancel"
    ></preview>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import wangEditor from '@components/wang-editor'
import tagRules from '@components/tag-rules'
// import ActivityCodeSwitch from '@components/activity-code-switch'
import preview from './components/preview'
import neditor from '@components/neditor'
export default {
  components: {
    wangEditor,
    tagRules,
    preview,
    neditor
    // ActivityCodeSwitch
  },
  data () {
    return {
      dialogData: {
        title: '',
        rules: [],
        cover: '',
        context: '',
        type: 'add',
        qrCodeInfo: {
          qrCodeId: ''
        },
        summary: '' // 摘要
      },
      formData: {},
      imagesLoading: false,
      // * 表单验证规则
      rules: {
        title: [{ required: true, message: '请输入案例标题', trigger: 'blur' }],
        cover: [
          { required: true, message: '请上传封面图片', trigger: 'change' }
        ],
        context: [
          { required: true, message: '请输入案例内容', trigger: 'change' }
        ]
      },
      showPreview: false,
      // 是否展示页面，为了保证编辑时，规则组件以及活码回显正确
      isShowPage: false,
      // 是否展示活码停用状态icon
      qrCodeWarningStatus: false,
      // 滚动元素
      scrollDom: null
    }
  },
  activated () {
    if (this.$route.query.id) {
      this.type = 'edit'
      this.getInitData()
    } else {
      this.type = 'add'
      this.isShowPage = true
      // neditor
      this.initScrollDom()
    }
  },
  deactivated () {
    this.setFormText('')
    window.sessionStorage.setItem('MarketingMterialTabName', 'case')
    this.dialogData = {
      title: '',
      rules: [],
      cover: '',
      context: '',
      type: 'add',
      summary: '', // 摘要
      qrCodeInfo: {
        qrCodeId: ''
      }
    }
    this.formData = {}
    this.imagesLoading = false
    this.showPreview = false
    this.$destroy()
  },
  methods: {
    ...mapMutations('system', {
      setFormText: 'SET_FORMTEXT'
    }),
    async getInitData () {
      // 初始化数据
      // const res = await BIZAPIS.MaterialArticleApi.materialArticleGet({
      // 替换成V2 MaterialSvc 接口
      const res = await MKMATERIALSVC.CaseApi.caseDetailGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.dialogData.title = data.title
        this.dialogData.cover = data.cover
        this.dialogData.context = data.context
        this.dialogData.summary = data.summary
        // 数据是否含有 活码信息
        if (data.qrCodeInfo) {
          this.dialogData.qrCodeInfo = data.qrCodeInfo
          // 如果活码为 停用状态，展示活码异常状态
          if (!data.qrCodeInfo.isEnable) {
            this.qrCodeWarningStatus = true
          }
        }
        // 2020-09-25 新增contactOpt字段，0:无 1:员工二维码 2:活码
        this.dialogData.contactOpt = data.contactOpt
        this.dialogData.key = Number(new Date().getTime())
        this.setFormText(' —— ' + data.title)

        const { rules } = data

        this.dialogData.rules = rules

        // 为保证 子组件props接值正确
        this.$nextTick(() => {
          this.isShowPage = true
          // neditor
          this.initScrollDom()
        })
      }
    },
    // 往 neditor 编辑器内传入 滚动的dom元素，用于子级监听滚动事件
    initScrollDom () {
      this.$nextTick(() => {
        // 往 neditor 编辑器内传入 滚动的dom元素，用于子级监听滚动事件
        this.scrollDom = this.$refs.content
      })
    },
    /**
     * * 图片上传事件
     */
    onImageUpload (res) {
      if (res.type === 'success') {
        this.imagesLoading = false
        this.uploadSuccess(res)
      } else if (res.type === 'fail') {
        this.imagesLoading = false
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoading = true
      }
    },

    /**
     * * 图片上传成功
     */
    uploadSuccess (res) {
      this.dialogData.cover = res.result.url
      this.$refs.cover.clearValidate()
    },
    gotoBottom () {
      let height = this.$refs.contentC.offsetHeight
      this.$refs.content.scrollTop = height
    },
    gotoTop () {
      this.$refs.content.scrollTop = 0
    },
    goBack () {
      this.$confirm('内容将不会被保存', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        window.sessionStorage.setItem('MarketingMterialTabName', 'case')
        history.go(-1)
      })
    },
    cancel () {
      this.showPreview = false
    },
    preview () {
      this.$refs.articleForm.validate(valid => {
        if (valid) this.showPreview = true
      })
    },
    /**
     * * 验证输入的数据是否符合规则
     */
    checkFormData () {
      this.$refs.articleForm.validate(valid => {
        if (valid) {
          if (this.dialogData.context) {
            if (this.$refs.tagRules.doCheck()) {
              this.saveFun()
            }
          } else {
            this.$message({
              type: 'error',
              message: '请输入案例内容',
              showClose: true
            })
          }
        }
      })
    },
    /**
     * *获取当前所选择的活码id
     */
    getActivityCode (qrCodeId) {
      this.dialogData.qrCodeInfo.qrCodeId = qrCodeId
    },
    /**
     * 当前活码为失效时，开启活码开关后，隐藏异常提示
    */
    getEnableCodeStatus (val) {
      this.qrCodeWarningStatus = val
    },
    /**
     * * 保存案例：根据type，调用不同的接口
     */
    async saveFun () {
      if (this.dialogData.contactOpt === 2 && this.dialogData.qrCodeInfo.qrCodeId === '') {
        this.$message.error('请选择活码')
        return
      }
      this.isBtnLoading = true
      const { title, cover, summary, context, rules, qrCodeInfo, contactOpt } = this.dialogData
      const params = {
        title,
        cover,
        summary,
        context,
        rules,
        qrCodeId: qrCodeInfo.qrCodeId,
        // 原创案例
        sourceType: 1,
        contactOpt
      }
      let res = {}
      let msg = '新增案例成功！'
      if (this.type === 'add') {
        // 新增案例接口
        res = await MKMATERIALSVC.CaseApi.caseCreatePost(params)
      } else {
        msg = '更新成功！'
        params._id = this.$route.query.id
        // 编辑案例接口
        res = await MKMATERIALSVC.CaseApi.caseUpdatePost(params)
      }
      if (res.success) {
        this.$message({
          type: 'success',
          message: msg
        })
        window.sessionStorage.setItem('MarketingMterialTabName', 'case')
        history.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.original-article {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 2;

  /deep/ .icon-mk-xinzeng {
    color: #d4d4d4 !important;
  }

  /deep/ .w-e-text-container {
    z-index: 1998 !important;
    min-height: 200px !important;
    height: auto !important;

    .w-e-text {
      min-height: 200px !important;
      overflow: hidden !important;
    }
  }

  .content {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    .editor,
    .form {
      width: calc(100% - 60px);
      margin: 0 auto;
    }

    /deep/ .w-e-menu {
      z-index: 1999 !important;
    }

    /deep/ .el-form-item {
      margin-bottom: 20px;
    }

    /deep/ .upload-cover {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      background-color: #fafafa;
      border-radius: 4px;
      border: 1px dashed #d4d4d4;

      .cover-div {
        position: relative;
        width: 60px;
        height: 60px;

        .cover-img {
          width: 100%;
          height: 100%;
        }

        .icon {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          color: #f5222d;
        }

        &:hover {
          .icon {
            display: block;
          }
        }
      }

      .plus-icon {
        font-size: 27px;
      }
    }

    .form-title {
      width: calc(100% - 60px);
      margin: 0 auto;
      display: flex;
      font-size: 14px;
      color: #262626;
      font-weight: 500;
      margin-bottom: 16px;
      margin-top: 30px;

      span {
        display: block;
        width: 4px;
        height: 16px;
        background-color: #009cff;
        border-radius: 1px;
        margin-right: 8px;
      }
    }
  }

  .qrcode-tips {
    color: #ff6b6b;
    font-size: 13px;
    margin-right: 6px;
  }

  .tips {
    margin-top: 5px;
    color: #8c8c8c;
    font-size: 12px;
    line-height: normal;
  }

  .handle {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
  }

  .handle-btn-bottom,
  .handle-btn-top {
    width: 98px;
    height: 32px;
    background-color: #009cff;
    border-radius: 32px;
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;

    .icon {
      color: #fff;
      font-size: 12px;
      margin-right: 4px;
    }
  }

  .handle-btn-bottom:hover,
  .handle-btn-top:hover {
    opacity: 0.8;
  }

  .handle-btn-top {
    position: absolute;
    bottom: 77px;
    right: 40px;
    z-index: 1100;
  }

  .handle-btn-bottom {
    position: absolute;
    bottom: 145px;
    right: 40px;
    z-index: 1100;
  }

  .mk-form-item-title {
    margin-top: -4px;
  }

  .mk-form-item-cover {
    margin-top: -4px;
  }

  .mk-form-item-tag-rules {
    margin-top: -12px;

    /deep/ .tag-tip {
      margin-bottom: 16px;
    }
  }

  .mk-form-item-live-code {
    margin-top: -24px;
  }

  .mk-form-item-summary {
    margin-top: -2px;
  }

  /deep/ .el-textarea {
    .el-input__count {
      background-color: transparent;
      line-height: 18px !important;
    }
  }

  /deep/ .title-input {
    input {
      padding-right: 44px;
    }

    .el-input__suffix {
      span {
        color: #909399;
        background: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
